import { Row, Typography } from "antd";

// Components
import FollowUpsCard from "../components/Dashboard/FollowUpsCard";
import NotificationsCard from "../components/Dashboard/NotificationsCard";
import StatsCards from "../components/Dashboard/StatsCards";
import { DashboardWrapper } from "../components/DashboardWrapper/DashboardWrapper.styles";

const { Title } = Typography;

const HomePage = () => {
  return (
    <DashboardWrapper>
      <StatsCards />

      <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        <FollowUpsCard />
        <NotificationsCard />
      </Row>
    </DashboardWrapper>
  );
};

export default HomePage;
